 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const opt = select.options[select.selectedIndex]
      const item = select.closest('.cart-drawer-upsell-list-item')
      const imgSrc = opt.dataset.variantImg
      if (imgSrc && item) {
        const img = item.querySelector('.cart-drawer-upsell-list-item-left img')
        if (img) img.src = imgSrc
      }
      const price = opt.dataset.price
      const priceEl = item && item.querySelector('[data-upsell-price]')
      if (price && priceEl) priceEl.textContent = price
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();


/* ===== HCE — Carrousel upsell "Completez votre equipement" =====
   Points de pagination + auto-scroll 3s + sync au scroll.
   Cible la liste VISIBLE injectee dans le drawer (insertAdjacentHTML
   n'execute pas les <script>, donc la logique vit ici). */
(function(){
  function base(items){ return items[0].offsetLeft; }
  function initOne(list){
    if(list.dataset.carouselInit) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.cart-drawer-upsell-list-item'));
    if(items.length < 1) return;
    list.dataset.carouselInit = '1';
    var scope = list.closest('#cart-drawer-upsell') || list.parentNode;
    var dotsWrap = scope ? scope.querySelector('.cart-drawer-upsell-dots') : null;
    var dots = [];
    var current = 0;
    var timer = null;

    function setActive(i){
      current = i;
      dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx === i); });
    }
    function goTo(i){
      if(i < 0) i = items.length - 1;
      if(i >= items.length) i = 0;
      list.scrollTo({ left: items[i].offsetLeft - base(items), behavior: 'smooth' });
      setActive(i);
    }
    function start(){
      if(items.length < 2) return;
      timer = setInterval(function(){
        if(!document.body.contains(list)){ clearInterval(timer); return; }
        goTo(current + 1);
      }, 5000);
    }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function reset(){ stop(); start(); }

    if(dotsWrap && items.length > 1){
      dotsWrap.innerHTML = '';
      items.forEach(function(it, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cart-drawer-upsell-dot';
        b.setAttribute('aria-label', 'Produit ' + (i + 1));
        b.addEventListener('click', function(){ goTo(i); reset(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }
    setActive(0);

    var st;
    list.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var c = 0, m = Infinity;
        items.forEach(function(it, idx){
          var dd = Math.abs((it.offsetLeft - base(items)) - list.scrollLeft);
          if(dd < m){ m = dd; c = idx; }
        });
        setActive(c);
      }, 100);
    }, { passive: true });

    start();
    list.addEventListener('mouseenter', stop);
    list.addEventListener('mouseleave', start);
    list.addEventListener('touchstart', stop, { passive: true });
    list.addEventListener('touchend', reset, { passive: true });
  }

  /* === Tri intelligent upsell selon le contenu du panier (2026-07-14) === */
  var CATEGORY_MAP = {"harnais-canicross-avec-laisse":"mainslibres","harnais-canicross-reflechissant-jaune":"mainslibres","harnais-canicross-reflechissant-noir":"mainslibres","harnais-canicross-reflechissant-rouge":"mainslibres","harnais-canicross-vert":"mainslibres","harnais-chien-actif-respirant":"crottes","harnais-chien-anti-traction-airtag":"tactique","harnais-chien-anti-traction-anti-fugue":"tactique","harnais-chien-anti-traction-ergonomique":"tactique","harnais-chien-anti-traction-floral":"tactique","harnais-chien-anti-traction-leger":"tactique","harnais-chien-anti-traction-original":"tactique","harnais-chien-anti-traction-promenade":"tactique","harnais-chien-anti-traction-reflechissant":"tactique","harnais-chien-anti-traction-rembourre":"tactique","harnais-chien-anti-traction-renforce":"tactique","harnais-chien-anti-traction-securite":"tactique","harnais-chien-anti-traction-tactique":"tactique","harnais-chien-bleu-reflechissant":"poignee","harnais-chien-en-cuir":"crottes","harnais-chien-gris":"crottes","harnais-chien-handicape-bleu":"poignee","harnais-chien-handicape-bleu-renforce":"poignee","harnais-chien-handicape-camouflage":"poignee","harnais-chien-handicape-gris":"poignee","harnais-chien-handicape-noir":"poignee","harnais-chien-handicape-rose":"poignee","harnais-chien-handicape-violet":"poignee","harnais-chien-macaron":"crottes","harnais-chien-noir":"crottes","harnais-chien-noir-reflechissant":"poignee","harnais-chien-poignee-maintien-renforce":"poignee","harnais-chien-poignee-polyvalent":"poignee","harnais-chien-poignee-reflechissant":"poignee","harnais-chien-reflechissant-ajustable":"poignee","harnais-chien-rose":"crottes","harnais-chien-rouge":"crottes","harnais-chien-rouge-reflechissant":"poignee","harnais-chiot-classique-ajustable":"crottes","harnais-chiot-doux-colore":"crottes","harnais-chiot-maille-respirante":"crottes","harnais-chiot-respirant-multicolore":"crottes","harnais-chiot-respirant-reglable":"crottes","harnais-chiot-souple-respirant":"crottes","harnais-chiot-veste-respirante":"crottes","harnais-petit-chien-chic":"crottes","harnais-petit-chien-confortable":"poignee","harnais-petit-chien-maille-respirante":"crottes","harnais-petit-chien-motif-respirant":"crottes","harnais-petit-chien-selle-ajustable":"crottes","harnais-petit-chien-tactique-leger":"tactique","harnais-randonnee-attache-sacoche":"mainslibres","harnais-randonnee-impermeable":"mainslibres","harnais-randonnee-sacoche-bleu":"mainslibres","harnais-randonnee-sacoche-camouflage":"mainslibres","harnais-randonnee-sacoche-gris":"mainslibres","harnais-randonnee-sacoche-jaune":"mainslibres","harnais-randonnee-sacoche-noir":"mainslibres","harnais-randonnee-sacoche-vert":"mainslibres","harnais-tactique-chien-colore":"tactique","harnais-tactique-chien-entrainement":"tactique","harnais-tactique-chien-modulable":"tactique","harnais-tactique-chien-molle":"tactique","harnais-tactique-chien-oxford":"tactique","harnais-tactique-chien-patchs":"tactique","harnais-tactique-chien-pochettes":"tactique","harnais-tactique-chien-reflechissant":"tactique","sangle-chien-handicape-arriere":"poignee","sangle-chien-handicape-noire":"poignee"};
  var TARGET_HANDLE = {tactique:"laisse-tactique-amortissante-double-poignee",mainslibres:"laisse-elastique-reflechissante-mains-libres-chien",poignee:"laisse-reflechissante-renforcee-poignee-rembourree",crottes:"distributeur-sacs-crottes-chien"};

  function pickCategory(handles){
    var counts = {}, order = [];
    handles.forEach(function(h){
      var c = CATEGORY_MAP[h];
      if(!c) return;
      if(!(c in counts)){ counts[c] = 0; order.push(c); }
      counts[c]++;
    });
    if(!order.length) return null;
    order.sort(function(a, b){ return counts[b] - counts[a]; });
    return order[0];
  }

  function reorderList(list, handle){
    if(!handle) return;
    var li = list.querySelector('li[data-handle="' + handle + '"]');
    if(li && list.firstElementChild !== li){
      list.insertBefore(li, list.firstElementChild);
    }
  }

  function applySmartOrder(lists){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var handles = (cart.items || []).map(function(i){ return i.handle; });
      var cat = pickCategory(handles);
      var target = cat ? TARGET_HANDLE[cat] : null;
      lists.forEach(function(list){ reorderList(list, target); });
    }).catch(function(){});
  }

  function scan(){
    var lists = Array.prototype.slice.call(document.querySelectorAll(
      '.cart-drawer-items-wrapper .cart-drawer-upsell-list, #CartDrawer .cart-drawer-upsell-list'
    ));
    var withItems = lists.filter(function(l){
      return l.querySelectorAll('.cart-drawer-upsell-list-item').length > 0;
    });
    var uninitialized = withItems.filter(function(l){ return !l.dataset.carouselInit; });
    if(uninitialized.length){
      applySmartOrder(uninitialized).then(function(){
        withItems.forEach(initOne);
      });
    } else {
      withItems.forEach(initOne);
    }
  }
  document.addEventListener('DOMContentLoaded', scan);
  setInterval(scan, 800);
  scan();
})();
